import React from "react";
import Header from "../../components/ChooseSection/Navbar/Header";
import Footer from "../../components/Footer/Footer";
// import "./About.css";



function History() {
  return (
    <div className="about-page">
      <Header />
      <header className="height-75">
        <div className="container h-100 d-flex flex-column align-items-center justify-content-center text-light">
          <h1 className="text-center fw-semibold">Privacy Policy</h1>
        </div>
      </header>

      <div className="container my-5">
        <div className="row">
          <div className=" d-flex flex-column text-align-justify justify-content-center mb-4 mb-lg-0">
            <h2 className="mb-4 mb-lg-5">Privacy Policy</h2>
            <p className="mb-4 mb-lg-5" style={{ textAlign: "justify" }}>
             This Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Your information when You use the Service and tells You about Your privacy rights and how the law protects You.
We use Your Personal data to provide and improve the Service. By using the Service, You agree to the collection and use of information in accordance with this Privacy Policy. This Privacy Policy has been created with the help of the Privacy Policy Generator.

              <br />   <br /> 
              <h5>Interpretation and Definitions</h5>
<h6>Interpretation</h6>
The words of which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.

            </p>

            <p className="mb-4 mb-lg-5" style={{ textAlign: "justify" }}>
              The College is affiliated to the Dr Ram Manohar Lohia Awadh University of Faizabad for teaching courses leading to B.A. and B.Sc. degree examinations.The College is also recognized for registration of students for Post-Graduation in the subjects of Hindi, Sociology, Education, and Home Science Studies.

              The College has a well-qualified, experienced and committed teaching faculty.
              <br /> <br />
              Our faculty is interacting with students directly and they will know each student by name and better yet, will know the students’ strengths and weaknesses. extra-curricular activities includingScout & Guide ,NSS, Cultural Programesand Sports, etc., the performance of students is excellent
            </p>


<h6>Definitions</h6>
            <p className="mb-4 mb-lg-5" style={{ textAlign: "justify" }}>
              For the purposes of this Privacy Policy:<br/>
             <b>Account</b>  means a unique account created for You to access our Service or parts of our Service.<br/>
<b>Affiliate</b> means an entity that controls, is controlled by or is under common control with a party, where "control" means ownership of 50% or more of the shares, equity interest or other securities entitled to vote for election of directors or other managing authority.<br/>
<b>Company</b> (referred to as either "the Company", "We", "Us" or "Our" in this Agreement) refers to pandit ram kedar ram kishor.<br/>
<b>Cookies</b> are small files that are placed on Your computer, mobile device or any other device by a website, containing the details of Your browsing history on that website among its many uses.<br/>
<b>Country</b> refers to: Uttar Pradesh, India

              <br /> <br />
             Device means any device that can access the Service such as a computer, a cellphone or a digital tablet.
Personal Data is any information that relates to an identified or identifiable individual.
Service refers to the Website.
Service Provider means any natural or legal person who processes the data on behalf of the Company. It refers to third-party companies or individuals employed by the Company to facilitate the Service, to provide the Service on behalf of the Company, to perform services related to the Service or to assist the Company in analyzing how the Service is used.

            </p>
            
            

            

       
          </div>
          {/* <div className="col-lg-6 d-flex justify-content-center">
            <img
              src="./img/banner-acm.png"
              className="img-fluid h-25 w-100"
              alt=""
            />
          </div> */}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default History;
